import { MagnetDriver } from '../device'
import { DataDeadZone, MagnetKeyInfo, postMagnetKeyInfo } from '@libs/types/response'
import { DeviceProtocol } from '@hid/device/device_model'
import { nd68Driver } from '../nd68'
import { RoyuanMagnetMode, RoyuanMagnetOptions, getRoyuanMagnetMode, royuanMagnetModeConvert } from '../data_conversion/nd68'
import { joinBytes } from '../tool'
import { KeyCode, KeyFunction, OutputMode, VirtualMars68, VK } from '@hid/define/define'
import { delay, generateMessageID } from '@libs/utils/tools'
import { DVKFromVK, HIDFromVk, allKeysForDevice, kkFromVK } from '@hid/define/define_fn'
import { deviceManager } from '@hid/device/device_manager'
import { DeviceConnectMode, MagnetSeniorType } from '@libs/types/enum'
import { fakeSocket } from '@hid/fakesocket/fakesocket'
import { KK } from '@hid/define/define'
import { DriverSocketMsgType } from '@libs/types/message'
import defineType from '@hid/define/define_type'
import { TravelPostData } from '@hid/common/types'
export class nd68Magnet extends MagnetDriver {
  shouldStop = false
  constructor(
    private DeviceHID: DeviceProtocol,
    private parent: nd68Driver,
  ) {
    super()
  }

  keysCalibration: { [index: KK]: boolean } = {}
  isCalibrating = false
  async startCalibration(): Promise<void> {
    this.isCalibrating = true
    const sendData = Array(64).fill(0)
    sendData[0] = 0x1e
    sendData[1] = 0x01
    await this.parent.sendData(sendData)
  }

  async endCalibration(): Promise<void> {
    console.log(this.DeviceHID)
    this.endTravels()
    if (this.isCalibrating) {
      this.isCalibrating = false
      const sendData = Array(64).fill(0)
      sendData[0] = 0x1e
      await this.parent.sendData(sendData)
    }
    this.keysCalibration = {}
    await delay(200)
  }

  async startTravels(): Promise<void> {
    this.shouldStop = false
    const keys = await allKeysForDevice(deviceManager.deviceID)

    for (let time = 0; true; time++) {
      const data: TravelPostData[] = []
      const fluxData: TravelPostData[] = []

      if (this.shouldStop || this.parent.connectMode == DeviceConnectMode.Wireless24G) {
        return
      }

      try {
        const res = await this.parent.getMagnet(RoyuanMagnetOptions.KEY_PRESS_DYNAMIC_TRAVEL)
        await delay(10)
        if (this.shouldStop) {
          return
        }
        const res1 = await this.parent.getMagnet(RoyuanMagnetOptions.KEY_PRESS_DYNAMIC_VALUE)
        // res.forEach((key, index) => {
        //     if (key>0 && index> 0){
        //         console.log(index,"index:")
        //     }
        // })
        keys.forEach((key) => {
          const baseIndex = key * 2
          const travel = joinBytes([res[baseIndex + 1], res[baseIndex]])
          const flux = joinBytes([res1[baseIndex + 1], res1[baseIndex]])
          if (travel > 0) {
            data.push({
              Key: key,
              Value: travel,
            })
          }
          if (flux > 0) {
            fluxData.push({
              Key: key,
              Value: flux,
            })
          }
          if (this.isCalibrating && travel > 330) {
            this.keysCalibration[key] = true
          }
        })
        fakeSocket.onmessage({
          data: JSON.stringify({
            ID: generateMessageID(),
            Type: 224,
            Data: data,
            Error: null,
          }),
        } as MessageEvent)

        fakeSocket.onmessage({
          data: JSON.stringify({
            ID: generateMessageID(),
            Type: 223,
            Data: fluxData,
            Error: null,
          }),
        } as MessageEvent)

        if (this.isCalibrating) {
          fakeSocket.onmessage({
            data: JSON.stringify({
              ID: generateMessageID(),
              Type: DriverSocketMsgType.MSMagnetWatchCalibratin,
              Data: this.keysCalibration,
              Error: null,
            }),
          } as MessageEvent)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  async endTravels(): Promise<void> {
    this.shouldStop = true
  }

  private keysTravel: Map<KK, MagnetKeyInfo> = new Map()
  private travelSynching = false
  async syncKeysTravels(): Promise<void> {
    if (this.parent.changeProfileFlag) {
      await delay(200)
    }
    this.travelSynching = true
    const keysMode = await this.parent.getKeysMode()
    const trvaels = this.parent.save.MagnetTravel

    const pressTravelData: number[] = Array(126 * 2).fill(0)
    const releaseTravelData: number[] = Array(126 * 2).fill(0)
    const rtPressTravelData: number[] = Array(126 * 2).fill(0)
    const rtReleaseTravelData: number[] = Array(126 * 2).fill(0)

    const setKeysMode: number[] = Array(126).fill(0)
    for (const [key, travel] of trvaels) {
      const mode = keysMode.get(key)
      if (mode != undefined) {
        setKeysMode[key] = mode
      }
      // 当模式不为undefined时，模式不为NORMAL和KME时，才需要设置行程   (mode & 0x0f) 包含了高级改键模式，所以需要&0x0f
      if (mode != undefined && (mode & 0x0f) != RoyuanMagnetMode.NORMAL && (mode & 0x0f) != RoyuanMagnetMode.KME) {
        const keyTravel = this.keysTravel.get(key)
        if (keyTravel != undefined) {
          console.log('syncKeysTravels', key, keyTravel)
          travel.PressNum = keyTravel.PressNum
          travel.ReleaseNum = keyTravel.ReleaseNum
          travel.QuickTriggerPressNum = keyTravel.QuickTriggerPressNum
          travel.QuickTriggerReleaseNum = keyTravel.QuickTriggerReleaseNum
        }
      } else {
        if (travel.QuickTriggerPressNum > 0 || travel.QuickTriggerReleaseNum > 0) {
          if (mode != undefined) {
            setKeysMode[key] = RoyuanMagnetMode.RT | mode
          }
        }
      }

      // 当rt的值是0时，但模式时rt模式，应该去掉rt模式
      if (travel.QuickTriggerPressNum == 0 && travel.QuickTriggerReleaseNum == 0 && (setKeysMode[key] & 0xf0) == RoyuanMagnetMode.RT) {
        setKeysMode[key] = setKeysMode[key] & 0x0f
      }

      const baseIndex = key * 2
      pressTravelData[baseIndex] = travel.PressNum & 0xff
      pressTravelData[baseIndex + 1] = (travel.PressNum >> 8) & 0xff

      releaseTravelData[baseIndex] = travel.ReleaseNum & 0xff
      releaseTravelData[baseIndex + 1] = (travel.ReleaseNum >> 8) & 0xff

      rtPressTravelData[baseIndex] = travel.QuickTriggerPressNum & 0xff
      rtPressTravelData[baseIndex + 1] = (travel.QuickTriggerPressNum >> 8) & 0xff

      rtReleaseTravelData[baseIndex] = travel.QuickTriggerReleaseNum & 0xff
      rtReleaseTravelData[baseIndex + 1] = (travel.QuickTriggerReleaseNum >> 8) & 0xff
    }
    await this.parent.setMagnet(RoyuanMagnetOptions.PRESS_TRAVEL, pressTravelData)
    await this.parent.setMagnet(RoyuanMagnetOptions.RELEASE_TRAVEL, releaseTravelData)
    await this.parent.setMagnet(RoyuanMagnetOptions.RT_RELEASE_TRAVEL, rtReleaseTravelData)
    await this.parent.setMagnet(RoyuanMagnetOptions.RT_PRESS_TRAVEL, rtPressTravelData)
    await this.parent.setMagnet(RoyuanMagnetOptions.KEY_MODE, setKeysMode, true)

    this.travelSynching = false
  }

  async syncSeniorkey(): Promise<void> {
    if (this.parent.changeProfileFlag) {
      const needSetCount = this.parent.save.Keys.filter((key) => key.Output.Mode == OutputMode.Magnet)
      if (needSetCount.length > 0) {
        await delay(500)
      } else {
        return
      }
    }
    const keysMode = await this.parent.getKeysMode()
    const setModeList: Map<KK, RoyuanMagnetMode> = new Map()

    for (const [key, mode] of keysMode) {
      setModeList.set(key, mode)
    }

    const mtData = Array(126).fill(0)
    const dksTravel = Array(126 * 2).fill(0)

    const setKeysData: Map<KK, number[]>[] = []

    for (let index = 0; index < this.parent.save.Keys.length; index++) {
      const value = this.parent.save.Keys[index]
      if ((value.Input.KK as any) === -1) continue
      if (value.Output.Mode == OutputMode.Magnet) {
        const magnetData = this.parent.save.MagnetData.get(value.Output.DataIndex)
        if (magnetData) {
          if (magnetData.KeyType != MagnetSeniorType.SeniorKeyTypeKME) {
            for (let index = 0; index < magnetData.Keys.length; index++) {
              if (magnetData.Keys[index] && magnetData.Keys[index].KeyCode.length > 0) {
                const setCode = this.handleMagnetSetKey(magnetData.Keys[index].KeyCode)
                if (setKeysData[index] == undefined) {
                  setKeysData[index] = new Map()
                }
                setKeysData[index].set(value.Input.KK, setCode)
              }
            }
          }

          let kmeMode = RoyuanMagnetMode.NORMAL
          const keyKmeMode = keysMode.get(value.Input.KK)
          if (keyKmeMode != undefined) {
            const modeTemp = keyKmeMode & 0xf0
            kmeMode = modeTemp | getRoyuanMagnetMode(magnetData.KeyType, magnetData.TGLMode)
          }
          setModeList.set(value.Input.KK, kmeMode)

          // await this.setDKS(value.Input.KK, magnetData)
          // await this.setMT(value.Input.KK, magnetData)
          // await this.setKME(value.Input.KK, magnetData)

          if (magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeDKS) {
            dksTravel[value.Input.KK * 2] = (magnetData.Keys[0].Travel * 10) & 0xff
            dksTravel[value.Input.KK * 2 + 1] = ((magnetData.Keys[0].Travel * 10) >> 8) & 0xff
            let dksFunction: [number, number, number, number] = [this.setTrPSx(magnetData.Keys[0].KeyFunction), this.setTrPSx(magnetData.Keys[1].KeyFunction), this.setTrPSx(magnetData.Keys[2].KeyFunction), this.setTrPSx(magnetData.Keys[3].KeyFunction)]
            await this.parent.setKeyMagnet(RoyuanMagnetOptions.DYNAMIC_KEY_FLAG, value.Input.KK, dksFunction)
            continue
          }

          if (magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeMT) {
            mtData[value.Input.KK] = magnetData.MTDuration
            continue
          }

          if (magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeKME) {
            const kk = kkFromVK(magnetData.Keys[0].KeyCode[0] as VK, deviceManager.deviceID)
            if (kk != undefined) {
              await this.parent.setKeyMagnet(RoyuanMagnetOptions.KME, value.Input.KK, [kk])
            } else {
              throw new Error('Unknown key code' + kk + '-' + magnetData.Keys[0].KeyCode[0])
            }
          }
        }
      }
    }
    await this.parent.setKeyIndexMap(setKeysData, true)
    await delay(200)

    if (!this.arrAllElementsZero(dksTravel)) {
      await this.parent.setMagnet(RoyuanMagnetOptions.DYNAMIC_PRESS_TRAVEL, dksTravel)
    }
    if (!this.arrAllElementsZero(mtData)) {
      await this.parent.setMagnet(RoyuanMagnetOptions.MT_LONG_PRESS_TIME, mtData)
    }
    await this.parent.setKeysMode(setModeList, true)
    if (!this.parent.changeProfileFlag) {
      await delay(300)
      await this.clearKME()
    }
    await delay(200)
  }

  private arrAllElementsZero(arr: number[]): boolean {
    return arr.every((element) => element === 0)
  }

  async clearKME(): Promise<void> {
    const keys = this.parent.resetKmeKeys
    const keysType = await this.parent.getKeysMode()

    for (let index = 0; index < keys.length; index++) {
      const value = keys[index]

      const mode = keysType.get(value.Input.KK)
      if (mode != undefined) {
        const isWrite = index == keys.length - 1 ? true : false
        await this.parent.setKeyMagnet(RoyuanMagnetOptions.KEY_MODE, value.Input.KK, [mode & 0xf0], isWrite)
      }
    }
    this.parent.clearKmeKeys()
  }

  // async clearKME(): Promise<void> {
  //     await delay(500)
  //     const magnetKeys = this.parent.save.Keys.filter((value) => value.Output.Mode == OutputMode.Magnet)
  //     const kmeMagnetData: Map<KK, SetMagnetSenior> = new Map()
  //     for (let index = 0; index < magnetKeys.length; index++) {
  //         const kio = magnetKeys[index];
  //         const keyMagent = this.parent.save.MagnetData.get(kio.Output.DataIndex)
  //         if (keyMagent && keyMagent.KeyType == MagnetSeniorType.SeniorKeyTypeKME) {
  //             kmeMagnetData.set(kio.Input.KK, keyMagent)
  //         }
  //     }
  //     if (kmeMagnetData.size == 0) {
  //         return
  //     }

  //     const keysMode = await this.parent.getKeysMode()
  //     let toDels: KK[] = []
  //     for (const [key, magnetData] of kmeMagnetData) {
  //         const bindKey = kkFromVK(magnetData.Keys[0].KeyCode[0] as VK, deviceManager.deviceID)
  //         const keyMode = keysMode.get(key)
  //         const bindKeyMode = keysMode.get(bindKey)
  //         if ((keyMode != undefined && (keyMode & 0x0F) != RoyuanMagnetMode.KME) || (bindKeyMode != undefined && (bindKeyMode & 0x0F) != RoyuanMagnetMode.KME)) {
  //             toDels.push(key)
  //         }
  //     }

  //     console.log("nd68", toDels)

  //     for (let index = 0; index < toDels.length; index++) {
  //         const key = toDels[index];
  //         const keyData = this.parent.save.Keys.find((value) => value.Input.KK == key)
  //         if (keyData) {
  //             this.parent.save.Keys = this.parent.save.Keys.filter((value) => value.Input.KK != key || (value.Input.KK == key && value.Input.WithFN == true))
  //             this.parent.save.MagnetData.delete(keyData.Output.DataIndex)
  //         }

  //         await this.parent.setKeyMagnet(RoyuanMagnetOptions.KME, key, [0xFF])
  //         const keyMode = keysMode.get(key)
  //         if (keyMode) {
  //             const isWrite = index == toDels.length - 1 ? true : false
  //             await this.parent.setKeyMagnet(RoyuanMagnetOptions.KEY_MODE, key, [keyMode & 0xF0], isWrite)
  //         }
  //     }

  //     dataProfileManage().save()
  //     this.parent.clearKmeKeys()
  // }

  private handleMagnetSetKey(keyscode: KeyCode) {
    let keyCode: number[] = []
    keyscode.forEach((code) => {
      let key = HIDFromVk(code as VK)
      if (defineType.isMouse(code as VK)) {
        key = DVKFromVK(code as VK, VirtualMars68)
      }

      if (key) {
        keyCode.push(key)
      } else {
        throw new Error(`Unknown key code ${code}`)
      }
    })

    let setCode: number[] = []
    if (keyCode.length == 1) {
      if (defineType.isMouse(keyscode[0] as VK)) {
        setCode = [0x01, 0, keyCode[0], keyCode[0] >> 8]
      } else if (keyCode.length == 1) {
        setCode = [0x00, 0, keyCode[0], 0]
      }
    }
    if (keyCode.length == 2) {
      setCode = [0, 0, keyCode[0], keyCode[1]]
    }
    if (keyCode.length == 3) {
      setCode = [0, keyCode[0], keyCode[1], keyCode[2]]
    }
    return setCode
  }

  private setTrPSx(data: KeyFunction) {
    let res = 0
    let flag = ''
    for (let index = 0; index < data.length; index++) {
      if (data[index] == 0) {
        flag += '00'
      }
      if (data[index] == 1) {
        flag += '10'
      }
      if (data[index] > 1) {
        if (data[index + 1] < 2) {
          flag += '01'
        } else {
          flag += '11'
        }
      }
    }
    for (let index = 0; index < flag.length; index++) {
      res |= (flag[index] == '1' ? 1 : 0) << index
    }
    return res
  }

  // private async setDKS(key: KK, magnetData: SetMagnetSenior) {
  //     if (magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeDKS) {
  //         await this.parent.setKeyMagnet(RoyuanMagnetOptions.DYNAMIC_PRESS_TRAVEL, key, [magnetData.Keys[0].Travel*10])
  //         let dksFunction: [number, number, number, number] = [this.setTrPSx(magnetData.Keys[0].KeyFunction), this.setTrPSx(magnetData.Keys[1].KeyFunction), this.setTrPSx(magnetData.Keys[2].KeyFunction), this.setTrPSx(magnetData.Keys[3].KeyFunction)]
  //         await this.parent.setKeyMagnet(RoyuanMagnetOptions.DYNAMIC_KEY_FLAG, key, dksFunction)
  //     }
  // }

  // private async setMT(key: KK, magnetData: SetMagnetSenior) {
  //     if (magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeMT) {
  //         await this.parent.setKeyMagnet(RoyuanMagnetOptions.MT_LONG_PRESS_TIME, key, [magnetData.MTDuration])
  //     }
  // }

  // private async setKME(key: KK, magnetData: SetMagnetSenior) {
  //     if (magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeKME) {
  //         const kk = kkFromVK(magnetData.Keys[0].KeyCode[0] as VK, deviceManager.deviceID)
  //         await this.parent.setKeyMagnet(RoyuanMagnetOptions.KME, key, [kk])
  //     }
  // }

  async getKeysTravels(keys?: KK[]): Promise<postMagnetKeyInfo[]> {
    if (!keys) {
      keys = allKeysForDevice(deviceManager.deviceID)
    }

    const keysMode = await this.parent.getMagnet(RoyuanMagnetOptions.KEY_MODE)

    const pressTravelData: number[] = await this.parent.getMagnet(RoyuanMagnetOptions.PRESS_TRAVEL)
    const rtPressTravelData: number[] = await this.parent.getMagnet(RoyuanMagnetOptions.RT_PRESS_TRAVEL)
    const rtReleaseTravelData: number[] = await this.parent.getMagnet(RoyuanMagnetOptions.RT_RELEASE_TRAVEL)

    let res: postMagnetKeyInfo[] = []

    keys.forEach((key) => {
      const index = key * 2
      const rtMode = keysMode[key] & 0xf0
      const actionMode = keysMode[key] & 0x0f
      res.push({
        Key: key,
        KeyType: royuanMagnetModeConvert(actionMode),
        PressNum: joinBytes([pressTravelData[index + 1], pressTravelData[index]]),
        ReleaseNum: joinBytes([pressTravelData[index + 1], pressTravelData[index]]),
        QuickTriggerPressNum: rtMode == RoyuanMagnetMode.RT ? joinBytes([rtPressTravelData[index + 1], rtPressTravelData[index]]) : 0,
        QuickTriggerReleaseNum: rtMode == RoyuanMagnetMode.RT ? joinBytes([rtReleaseTravelData[index + 1], rtReleaseTravelData[index]]) : 0,
      })

      this.keysTravel.set(key, {
        PressNum: joinBytes([pressTravelData[index + 1], pressTravelData[index]]),
        ReleaseNum: joinBytes([pressTravelData[index + 1], pressTravelData[index]]),
        QuickTriggerPressNum: joinBytes([rtPressTravelData[index + 1], rtPressTravelData[index]]),
        QuickTriggerReleaseNum: joinBytes([rtReleaseTravelData[index + 1], rtReleaseTravelData[index]]),
      } as MagnetKeyInfo)

      if (key == 1) {
        console.log('key 1', this.keysTravel.get(key))
      }
    })

    return res
  }

  async readOrSetDeadZone(_isWrite: boolean, _value?: [number, number]): Promise<[number, number]> {
    return [0, 0]
  }

  async getKeysDeadZone(keys?: KK[]): Promise<Map<KK, DataDeadZone>> {
    const res = new Map<KK, DataDeadZone>()
    if (!keys) {
      keys = allKeysForDevice(deviceManager.deviceID)
      const travels: number[] = await this.parent.getMagnet(RoyuanMagnetOptions.DEADZONE)
      keys.forEach((key) => {
        const deadzone = joinBytes([travels[key * 2 + 1], travels[key * 2]])
        res.set(key, { Top: deadzone, Bottom: deadzone })
      })
    } else {
      for (let i = 0; i < keys.length; i++) {
        const resTravles = await this.parent.getKeyMagnet(RoyuanMagnetOptions.DEADZONE, keys[i])
        const deadzone = joinBytes([resTravles[1], resTravles[0]])
        res.set(keys[i], { Top: deadzone, Bottom: deadzone })
      }
    }
    return res
  }

  async syncKeysDeadZone(): Promise<void> {
    const deadZoneData: number[] = Array(126 * 2).fill(0)
    const deadZoneList = this.parent.save.DeadZoneList
    for (const [key, deadzone] of deadZoneList) {
      deadZoneData[key * 2] = deadzone.Top & 0xff
      deadZoneData[key * 2 - 1] = (deadzone.Top >> 8) & 0xff
    }
    await this.parent.setMagnet(RoyuanMagnetOptions.DEADZONE, deadZoneData, !this.travelSynching)
    if (this.parent.changeProfileFlag) {
      await delay(500)
    }
  }

  async DemoDebug(): Promise<void> {}

  destroy() {}
}
